import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApplicationForUser } from '../../../models/borrower-portal/application-for-user-model';
import { ApplicationTaskModel } from '../../../models/borrower-portal/application-task-model';

@Component({
    selector: 'tasks-income-employment',
    templateUrl: './tasks-income-employment.component.html',
    styleUrls: ['./tasks-income-employment.component.scss'],
    standalone: false
})
export class TasksIncomeAndEmploymentComponent implements OnInit {

  @Input() tasks: ApplicationTaskModel[] = [];
  @Input() application: ApplicationForUser;

  @Input() showIncomeEmploymentVerificationButton: boolean = true;
  @Input() isSubmitted: boolean;

  @Output() startIncomeEmploymentVerificationClicked = new EventEmitter<ApplicationTaskModel>();

  /** Tracks which task cards are expanded on mobile */
  protected expandedTaskIds = new Set<number>();
  
  constructor() { }

  ngOnInit(): void {
  }

  toggleTaskExpanded(taskId: number): void {
    if (this.expandedTaskIds.has(taskId)) {
      this.expandedTaskIds.delete(taskId);
    } else {
      this.expandedTaskIds.add(taskId);
    }
  }

  isTaskExpanded(taskId: number): boolean {
    return this.expandedTaskIds.has(taskId);
  }

  onStartIncomeEmploymentVerificationClicked = (task: ApplicationTaskModel) => {
    this.startIncomeEmploymentVerificationClicked.emit(task);
  }
}
